import type { UrlStatusUpdate } from '@kanbu/schema/contracts';
import { DocumentStatus } from '@kanbu/schema/enums';

type Props = {
  item: UrlStatusUpdate;
  isLoading?: boolean;
};

export function UrlListItem({ item, isLoading }: Props) {
  let progress = 0;
  switch (item.status) {
    case DocumentStatus.Uploading:
      progress = 16;
      break;

    case DocumentStatus.Ready:
      progress = 32;
      break;

    case DocumentStatus.Parsing:
    case DocumentStatus.ParsingAsync:
      progress = 48;
      break;

    case DocumentStatus.Parsed:
      progress = 64;
      break;

    case DocumentStatus.Embedding:
      progress = 80;
      break;

    case DocumentStatus.ParsingError:
    case DocumentStatus.EmbeddingError:
    case DocumentStatus.Done:
      progress = 100;
      break;

    default:
      progress = 0;
      break;
  }

  return (
    <li className='flex items-center justify-between gap-3 transition-colors duration-150'>
      <span
        className='w-4/5 truncate text-[11px] leading-[18px] text-[#1a1a1ab2]'
        title={item.url}
      >
        {item.url}
      </span>
      {isLoading && (
        <div className='relative h-1 w-1/5 shrink-0 rounded-full bg-[#ececec]'>
          <div
            className='absolute left-0 top-0 h-full w-0 rounded-full bg-[#9c70ff] transition-[width]'
            style={{ width: `${progress}%` }}
          />
        </div>
      )}
    </li>
  );
}
